export default [
  {
    id: 1,
    label: 'Bridal services',
    param: 'bridal'
  },
  {
    id: 2,
    label: 'Bridal party services',
    param: 'bridalParty'
  },
  {
    id: 3,
    label: 'Grooms services',
    param: 'grooms'
  },
  {
    id: 4,
    label: 'View All',
    param: 'all'
  }
];
